var _path, _circle, _circle2, _polygon, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultTeamBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 110",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 4 L94 20 L94 62 Q94 90 50 106 Q6 90 6 62 L6 20 Z",
    fill: "#1a3c6e",
    stroke: "#F5B800",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 56,
    r: 22,
    fill: "white",
    opacity: 0.92
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 56,
    r: 22,
    fill: "none",
    stroke: "#1a3c6e",
    strokeWidth: 1.5,
    opacity: 0.3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "50,44 58,49 58,59 50,64 42,59 42,49",
    fill: "#1a3c6e",
    opacity: 0.85
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 34,
    x2: 42,
    y2: 49,
    stroke: "#1a3c6e",
    strokeWidth: 1.2,
    opacity: 0.35
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 34,
    x2: 58,
    y2: 49,
    stroke: "#1a3c6e",
    strokeWidth: 1.2,
    opacity: 0.35
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 49,
    x2: 42,
    y2: 49,
    stroke: "#1a3c6e",
    strokeWidth: 1.2,
    opacity: 0.35
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 49,
    x2: 58,
    y2: 49,
    stroke: "#1a3c6e",
    strokeWidth: 1.2,
    opacity: 0.35
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 63,
    x2: 42,
    y2: 59,
    stroke: "#1a3c6e",
    strokeWidth: 1.2,
    opacity: 0.35
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 63,
    x2: 58,
    y2: 59,
    stroke: "#1a3c6e",
    strokeWidth: 1.2,
    opacity: 0.35
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 78,
    x2: 42,
    y2: 59,
    stroke: "#1a3c6e",
    strokeWidth: 1.2,
    opacity: 0.35
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 78,
    x2: 58,
    y2: 59,
    stroke: "#1a3c6e",
    strokeWidth: 1.2,
    opacity: 0.35
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "50,10 52,16 58,16 53,20 55,26 50,22 45,26 47,20 42,16 48,16",
    fill: "#F5B800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultTeamBadge);
export default __webpack_public_path__ + "static/media/default-team-badge.26e622137d933fea7d926fac226622b3.svg";
export { ForwardRef as ReactComponent };